import React from "react";
import { motion } from "framer-motion";

const Home = () => {
    return (
        <section
            id="home"
            className="min-h-screen flex items-center justify-center pt-16 pb-8 bg-cover bg-center relative"
            style={{ backgroundImage: 'url("/Images/homepage-background.jpg")' }}
        >
            {/* Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-40"></div>

            <div className=" max-w-7xl relative ">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">

                    {/* Sol taraf - Yazılar */}
                    <div className="text-white text-center lg:text-left px-4 order-2 lg:order-1">
                        <motion.h1
                            initial={{ x: -100, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ duration: 0.7 }}
                            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-lato font-bold mb-4 leading-tight"
                        >
                            ZENON GAMING
                        </motion.h1>

                        <motion.p
                            initial={{ x: -100, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ duration: 1, delay: 0.3 }}
                            className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-lato font-bold mb-4 lg:mb-6"
                        >
                            Oyun Bilgisayarlarında Yeni Nesil Güç
                        </motion.p>

                        <motion.p
                            initial={{ x: -100, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ duration: 1, delay: 0.6 }}
                            className="text-sm sm:text-base md:text-lg lg:text-xl font-montserrat leading-relaxed max-w-2xl mx-auto lg:mx-0"
                        >
                            Hemen harekete geçin ve bu canavar oyuncu bilgisayarını siz de edinin!
                            <br className="hidden sm:block" />
                            Rakiplerinizi geride bırakın ve oyun dünyasının hakimi olun!
                        </motion.p>
                    </div>

                    {/* Sağ taraf - Resim */}
                    <div className="flex justify-center lg:justify-end order-1 lg:order-2">
                        <motion.div
                            initial={{ y: -100, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 1, delay: 0.9 }}
                            className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl"
                        >
                            <img
                                src="/Images/products/zenon-pro-zg-120.png"
                                alt="Zenon Gaming PC"
                                className="w-full h-auto object-contain rounded-lg"
                            />
                        </motion.div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Home;